/*!
 * Copyright © 2018-2020. Verizon Connect Ireland Limited. All rights reserved.
 */

import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatLegacyButtonModule } from '@angular/material/legacy-button';
import { MatLegacyCardModule } from '@angular/material/legacy-card';
import { MatLegacyCheckboxModule } from '@angular/material/legacy-checkbox';
import { MatLegacyListModule } from '@angular/material/legacy-list';
import { TooltipModule } from 'shared';
import { ListSelectComponent } from './list-select.component';

@NgModule({
  imports: [CommonModule, TooltipModule, MatLegacyCheckboxModule, MatLegacyListModule, MatLegacyButtonModule, MatLegacyCardModule],
  exports: [ListSelectComponent],
  declarations: [ListSelectComponent]
})
export class ListSelectModule {}
